export default function EmptyView() {
  return (
    <div className="empty-state">
      <div className="empty-card">
        <h2>ZIP File Explorer</h2>

        <p className="empty-desc">
          We support Google Drive and Dropbox links, letting you explore ZIP
          files directly in your browser — no downloads, no extraction required.
        </p>

        <ul className="empty-features">
          <li>📂 Browse folders inside ZIP files</li>
          <li>📄 Read text & PDFs instantly</li>
          <li>🖼️ Preview images</li>
          <li>🔍 Search files by name</li>
        </ul>

        <div className="empty-hint">
          Start by loading a ZIP file from the sidebar.
        </div>
      </div>
    </div>
  );
}
